import angular from "angular";
// Note: this will also inject components at this stage due to coupling between
// the upload service and the UI components.
import ngFileUpload from "ng-file-upload";
import { EnvironmentModule } from '../env/environment.module';
import { configureHttpProvider } from "./blocks/http-provider.config";
import { configureSentryUser, configureSentry } from "./blocks/sentry.config";
import { TemplateCacheModule } from "./cache/template-cache.module";
import { FeatureFlagsModule } from "./feature-flags/feature-flags.module";
import { SentryModule } from "./sentry/sentry.module";
import { ApiClientService } from "./services/api-client.service";
import { BankAccountCreationPolicyService } from "./services/bank-account-creation-policy.service";
import { DataServiceModule } from "./services/data-services/data-service.module";
import { PermissionGrantService } from "./services/data-services/permission-grant.service";
import { FileService } from "./services/file.service";
import { InstanceDb } from "./services/instance-db.service";
import { LeadBatchJobTracker } from "./services/lead-batch-job-tracker.service";
import { LocaleService } from "./services/locale.service";
import { PasswordValidatorService } from "./services/password-validator.service";
import { PayrollManualCalculationService } from "./services/payroll-manual-calculation.service";
import { ReportJobTracker } from "./services/report-job-tracker.service";
import { SessionServiceV1 } from "./services/session-v1.service";
import { TimeZoneDetectorService } from "./services/time-zone-detector.service";
import { UtilityServiceFactory } from "./services/utility.service";

/** A module containing core business logic for the application. */
export const CoreModule = angular
    .module("apex.core", [
        ngFileUpload,
        SentryModule,
        // Use the environment defined in the EnvironmentModule
        EnvironmentModule,
        DataServiceModule,
        FeatureFlagsModule,
        TemplateCacheModule
    ])
    .service("apiClientService", ApiClientService)
    .service("bankAccountCreationPolicyService", BankAccountCreationPolicyService)
    .service("fileService", FileService)
    .service("instanceDb", InstanceDb)
    .service("leadBatchJobTracker", LeadBatchJobTracker)
    .service("localeService", LocaleService)
    .service("passwordValidatorService", PasswordValidatorService)
    .service("payrollManualCalculationService", PayrollManualCalculationService)
    .service("permissionGrantService", PermissionGrantService)
    .service("reportJobTracker", ReportJobTracker)
    .service("sessionService", SessionServiceV1)
    .service("timeZoneDetectorService", TimeZoneDetectorService)
    .factory("utilityService", UtilityServiceFactory)
    .config(configureHttpProvider)
    .config(configureSentry)
    .run(configureSentryUser)
    .name
